import { memo, useContext } from "react";

import appStyles from "../../../App.module.css";
import { formatAmount, formatDate } from "../../../app-constants";
import { CorporateGroupTravelContext } from "../../CorporateGroupTravel";
import { ICorporateGroupTravelContext } from "../../config/interfaces";

const CGOrderSummary = () => {
  const { quoteData, order } = useContext(CorporateGroupTravelContext) as ICorporateGroupTravelContext;

  return (
    <div className={`${appStyles.tripSummary} ${appStyles.CGTTripSummaryWarp}`}>
      <div className={`${appStyles.tripSummaryTitle}`}>
        <h4>Order Summary</h4>
      </div>
      <div className={appStyles.tripSummaryRow}>
        <div>Trip Duration</div>
        <div className={appStyles.tripSummaryValue}>
          {`${formatDate(quoteData.startDate)} to
            ${formatDate(quoteData.endDate)}`}
        </div>
      </div>

      <div className={appStyles.tripSummaryRow}>
        <div>Destination(s)</div>
        <div className={appStyles.tripSummaryValue}>
          {quoteData?.destinationCountries?.map((dest: any) => dest?.name).join(", ")}
        </div>
      </div>

      <div className={appStyles.tripSummaryRow}>
        <div>Number of Travelers</div>
        <div className={appStyles.tripSummaryValue}>{quoteData?.numberOfTravellers}</div>
      </div>

      <div className={appStyles.tripSummaryOrderBreakdown}>
        <div className={`${appStyles.tripSummaryRow} ${appStyles.tripSummaryOrderTotal}`}>
          <div>Total</div>
          <div className={`${appStyles.tripSummaryValue} ${appStyles.colorPrimary}`}>
            <div className={appStyles.tripSummaryValue}>
              {formatAmount(order?.total || 0, order?.applicant?.country_code, order?.currency_id)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CGOrderSummary);
